/*
 * @Author: luting
 * @Date: 2022-04-15 14:29:42
 * @lastEditors: luting
 * @LastEditTime: 2023-02-09 17:07:02
 */
import React from 'react';
import { Spin } from 'sup-ui';
import { useIntl } from 'react-intl';
import messages from '../messages';
// import ServiceInfo from 'root/components/ServiceInfo';
import styles from './index.less';

interface IConfirmDiskHead {
  currentProgress: string;
  err?: string;
}

const ConfirmDiskHead: React.FC<IConfirmDiskHead> = (props) => {
  const { currentProgress, err } = props;

  const intl = useIntl();

  const titleData: any = {
    selectDisk: {
      title: 'chooseWillUseDisk',
    },
    confirmDisk: {
      title: 'confirmDisk',
    },
    partitionDisk: {
      title: 'partitioningBlock',
      color: '#2280FA',
    },
    partitionFailed: {
      title: 'repartition',
      color: '#f00',
      messages: '',
    },
    repartitionNonstandard: {
      title: 'repartitionNonstandard',
      color: '#f00',
      messages: '',
    },
    confirmInstall: {
      title: 'repartitionSuccess',
      color: '#0AB129',
    },
    createDiskBlock: {
      title: 'createDiskBlock',
      color: '#2280FA',
    },
  };

  return (
    <div className={styles.serviceInfoBox}>
      {currentProgress !== 'selectDisk' && (
        <div>
          <span style={{ color: titleData[currentProgress]?.color || '#000' }} className={styles.confirmTitle}>
            {intl.formatMessage(messages[titleData[currentProgress]?.title])}
          </span>
          {currentProgress === 'partitionDisk' && <Spin style={{ paddingLeft: 10 }} size="small" />}

          {['partitionFailed', 'repartitionNonstandard'].includes(currentProgress) && (
            <div style={{ color: '#f00' }}>{err || ''}</div>
          )}
        </div>
      )}

      {/* <ServiceInfo /> */}
    </div>
  );
};

export default ConfirmDiskHead;
